import i18n from '../i18n/index'

// Известные коды ошибок бэкенда -> переведённый текст; meta - data.meta ответа сервера.
// null для неизвестного кода: вызывающий сам решает, что показывать
// (интерсептор http.js падает обратно на data.message, OFDPaymentNotifier - на сырой текст ОФД)
export default function backendErrorMessage(code, meta) {
  const i18nErrors = {
    WRONG_PASSWORD: i18n.t('backend/WRONG_PASSWORD'),
    DATA_INTEGRITY_ERROR: i18n.t('backend/DATA_INTEGRITY_ERROR'),
    INVALID_TOKEN: i18n.t('backend/INVALID_TOKEN'),
    UNKNOWN_ID: i18n.t('backend/UNKNOWN_ID'),
    CANT_CANCEL_TICKET: i18n.t('backend/CANT_CANCEL_TICKET'),
    NOT_ENOUGH_CASH: i18n.t('backend/NOT_ENOUGH_CASH', { cashSum: meta && meta.CURRENT_CASH_SUM }),
    CASH_REGISTER_SHIFT_PERIOD_EXPIRED: i18n.t('backend/CASH_REGISTER_SHIFT_PERIOD_EXPIRED'),
    CASH_REGISTER_SHOULD_HAVE_SHIFT_CLOSED: i18n.t('backend/CASH_REGISTER_SHIFT_PERIOD_EXPIRED'),
    CASH_REGISTER_OFFLINE_PERIOD_EXPIRED: i18n.t('backend/CASH_REGISTER_OFFLINE_PERIOD_EXPIRED', { hours: meta && Math.floor(meta.ALLOWED_OFFLINE_MINUTES / 60) }),
    CASH_REGISTER_BLOCKED: i18n.t('backend/CASH_REGISTER_BLOCKED'),
    BLOCKED: i18n.t('backend/CASH_REGISTER_BLOCKED'),
    CASH_REGISTER_WRONG_OFD_MODE: i18n.t('backend/CASH_REGISTER_WRONG_OFD_MODE'),
    CASH_REGISTER_ALREADY_ACTIVATED: i18n.t('backend/CASH_REGISTER_ALREADY_ACTIVATED'),
    CASH_REGISTER_ALREADY_REGISTERED: i18n.t('backend/CASH_REGISTER_ALREADY_REGISTERED'),
    CASH_REGISTER_TRIAL_PERIOD_EXPIRED: i18n.t('backend/CASH_REGISTER_TRIAL_PERIOD_EXPIRED'),
    CASH_REGISTER_TRIAL_OPERATIONS_LIMIT_REACHED: i18n.t('backend/CASH_REGISTER_TRIAL_OPERATIONS_LIMIT_REACHED'),
    CASH_REGISTER_CANNOT_RESTORE_ROLE: i18n.t('backend/CASH_REGISTER_CANNOT_RESTORE_ROLE'),
    CASH_REGISTER_ATTEMPT_LIMIT_EXCEEDED: i18n.t('backend/CASH_REGISTER_ATTEMPT_LIMIT_EXCEEDED'),
    CASH_REGISTER_SERVICE_FEE_PAYMENT_REQUIRED: i18n.t('backend/CASH_REGISTER_SERVICE_FEE_PAYMENT_REQUIRED'),
    SERVICE_TEMPORARILY_UNAVAILABLE: i18n.t('backend/SERVICE_TEMPORARILY_UNAVAILABLE'),
    PROTOCOL_ERROR: i18n.t('backend/PROTOCOL_ERROR'),
    SAME_TAXPAYER_AND_CUSTOMER: i18n.t('backend/SAME_TAXPAYER_AND_CUSTOMER', { iinbin: meta && meta.IIN_OR_BIN }),
    CASH_REGISTER_WRONG_STATUS: i18n.t('backend/CASH_REGISTER_WRONG_STATUS', { status: i18n.t(`cashRegister.status.${meta && meta.STATUS}`) }),
    CASH_REGISTER_WRONG_MODEL: i18n.t('backend/CASH_REGISTER_WRONG_MODEL'),
    DEREGISTERED: i18n.t('backend/DEREGISTERED'),
    DISCONNECTED: i18n.t('backend/DISCONNECTED'),
    INVALID_REQUEST_NUMBER: i18n.t('backend/INVALID_REQUEST_NUMBER'),
  }
  return (code && i18nErrors[code]) || null
}
